import { render, staticRenderFns } from "./SplitterGutter.vue?vue&type=template&id=4d331e68&"
import script from "./SplitterGutter.vue?vue&type=script&lang=js&"
export * from "./SplitterGutter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports